import React from 'react'

const FormStatus = ({ message, messageType = 'danger' }) => (
  <div className="FormStatus">
    <h6>{message}</h6>
  </div>
)

export default FormStatus
